import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { PromptsService } from './core/services/prompts.service';
import { AuthenticationService } from './core/services/auth.service';

import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { TableModule } from 'primeng/table';
import { SidebarModule } from 'primeng/sidebar';

import { DatePipe } from '@angular/common';
import { NgIdleModule } from '@ng-idle/core';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LayoutsModule,
    AppRoutingModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      timeOut: 4000,
      closeButton: true,
      progressBar: true,
      tapToDismiss: true,
      maxOpened: 1,
      autoDismiss: true
    }),
    TableModule,
    SidebarModule,
    NgIdleModule.forRoot()
  ],
  bootstrap: [AppComponent],
  providers: [
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (
        promptsService: PromptsService,
        authService: AuthenticationService,
      ) => () => {
        if (!authService.hasReadableAuthSession()) {
          return Promise.resolve(undefined);
        }
        return firstValueFrom(promptsService.ensureLoaded()).then(() => undefined);
      },
      deps: [PromptsService, AuthenticationService],
      multi: true
    }
  ],
})
export class AppModule { }
